import React, { useState, useEffect } from "react";
import Button from "../../components/base/Button.jsx";
import Section from "../../components/base/Section.jsx";
import OptionItem from "../../components/OptionItem.jsx";
import RequirementsPanel from "../../components/RequirementsPanel.jsx";
import { theme } from "../../theme.js";
import { PlusIcon } from "@heroicons/react/24/outline";

export default function CreateRaceOptions({options, requirements, setOptions, setRequirements}) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

    const handleAddOption = (option) => {
    setOptions([...options, option]);
  };

  const handleUpdateOption = (updatedOption) => {
    setOptions(
      options.map((opt) => (opt.key === updatedOption.key ? updatedOption : opt))
    );
  };

  const handleDeleteOption = (key) => {
    setOptions(options.filter((opt) => opt.key !== key));
  };

    return (
        <div style={styles.step1}>
        <div style={{ ...styles.mainColumn, marginLeft: isMobile ? theme.spacing.sm : theme.spacing.huge, marginRight: isMobile ? theme.spacing.sm : theme.spacing.huge }}>
          <Section title="Options disponibles">
            <p style={styles.description}>
              Les participants pourront choisir parmi ces options
            </p>
            {options.map((option) => (
              <OptionItem
                key={option.key}
                option={option}
                onUpdate={handleUpdateOption}
                onDelete={handleDeleteOption}
              />
            ))}
            <Button
              onClick={() =>
                handleAddOption({
                  key: Date.now().toString(),
                  id: Date.now(),
                  type: "other",
                  name: "",
                  price: 0,
                  required: false,
                  choices: [],
                })
              }
              style= "dark"
              title = "Ajouter une option"
              icon = {PlusIcon}
              >
            </Button>
          </Section>

          <Section title="Documents requis">
            <p style={styles.description}>
              Configurez les documents que les participants doivent apporter
            </p>
            <RequirementsPanel 
              requirements={requirements}
              setRequirements={setRequirements}
            />
          </Section>
        </div>
        </div>
    );
}

const styles = {
  step1: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.radius.lg,
    overflow: "hidden",
  },
  mainColumn: {
    padding: `${theme.spacing.massive} ${theme.spacing.lg}`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xxl,
    marginLeft: theme.spacing.huge,
    marginRight: theme.spacing.huge,
  },
  description: {
    margin: `0 0 ${theme.spacing.md} 0`,
    fontSize: theme.fonts.size.sm,
    color: theme.colors.textMuted,
    fontStyle: "italic",
  },
  addButton: {
    width: "100%",
    padding: `${theme.spacing.sm} ${theme.spacing.md}`,
    marginTop: theme.spacing.sm,
    backgroundColor: theme.colors.heroBlue,
    color: theme.colors.white,
    border: "none",
    borderRadius: theme.radius.lg,
    cursor: "pointer",
    fontWeight: theme.fonts.weight.semibold,
    fontSize: theme.fonts.size.sm,
    transition: theme.transitions.base,
  },
};
